import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_UPCOMING_INVESTMENT } from "../../../config/api";
import mixpanel from "mixpanel-browser";

export const getUpcomingInvestments = createAsyncThunk(
  "getOpenInvestments/get",
  async ({ cb, failed, currency }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: `${API_UPCOMING_INVESTMENT}?currency=${currency}&status=9&show_mudarabah=1`,
      });

      cb(data?.data);
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "portfolio",
      //   subtype: "get-my-portfolio",
      //   message: msg,
      // });
      failed();
      // toast.error(msg);
      throw error;
    }
  }
);
